import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ProjectCard = ({
  data: {
    image,
    projectExcerpt: { projectExcerpt },
    title,
    slug,
  },
}) => {
  const imageData = getImage(image)
  return (
    <Link to={`/projects/${slug}/`}>
      <div className="pb-8 mb-10">
        <GatsbyImage image={imageData} alt={title} className="mb-4" />
        <h5>{title}</h5>
        <p className="leading-6">{projectExcerpt}</p>
        <Link
          to={`/projects/${slug}/`}
          className="uppercase flex items-center button-link"
        >
          Read More
          <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`w-6 h-6 ml-2 chev`}
          >
            <path
              d="M10 16L14 12L10 8"
              stroke="#043042"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </Link>
      </div>
    </Link>
  )
}

export default ProjectCard
